var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};

/**
 * Logout confirmation dialog for when there are unsaved proposal fields
 */
Curriculog.ProposalForm.LogoutConfirmDialog = (function ($, _, Backbone, LogoutConfirmDialog) {
    LogoutConfirmDialog = Curriculog.WarningDialog.extend({
        message: 'You have unsaved changes on this page. If you log out these change will be lost.<br />Are you sure you want to log out?',
        buttons: {
            'Log Out': _.debounce(function() {
                window.onbeforeunload = null;
                access().logOut();
                Backbone.trigger('user:logout');
                this.close();
            },1000, true),

            'Cancel': function() {
                this.close();
            }
        },

        // this function is fired on close, including Esc
        releaseBackground: function() {
            this.form._logout_dialog = null;
            Curriculog.WarningDialog.prototype.releaseBackground.apply(this, arguments);
        }
    });
    return LogoutConfirmDialog;
})($, _, Backbone, Curriculog.ProposalForm.LogoutConfirmDialog || {});